import type { ComponentProps } from "react"

export default function Files1(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 1H10V4.186L10.814 5H14V12H12V13H15V3.6L11.4 0H5V2H6V1ZM11 1H11.31L14 3.69V4H11V1ZM11 6.6L7.4 3H1V16H11V6.6ZM10 15H2V4H6V8H10V15ZM10 7H7V4H7.31L10 6.69V7ZM3 9H9V10H3V9ZM7 12V13H3V12H7Z"
        fill={fill}
      />
    </svg>
  )
}
